import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0329',
    ecrans: ['00-2'],
    params: [
        'id',
        'bqecleint'
    ]
});
